import ReportsHome from "../views/ReportsHome.vue"

export default [
	{
		path: "/:tenantId/reports",
		component: ReportsHome,
		meta: { featureId: "reports" },
		props: true
	}
]
